import React, {Fragment} from 'react';
import {GoogleMap, Marker} from "@react-google-maps/api";
import {getMapIcon} from "../service/Icon";
import {DEFAULT_ZOOM} from "../Const";

const initialState = {
    map: null,
    ready: false,
    mapProps: {
        center: {
            lat: 50.8835239,
            lng: 10.2,
        },
        zoom: DEFAULT_ZOOM,
        loading: false,
        height: 'calc(100vh - 83px)'
    },
}

class MapView extends React.Component {

    static defaultProps = {
        categories: [],
        members: [],
        libraries: ['places'],
        cookieIsApproved: false,
        mapProps: {
            center: {
                lat: 50.8835239,
                lng: 10.2,
            },
            zoom: DEFAULT_ZOOM,
            loading: false
        },
        onMarkerClick: (event, member, index) => {
        },
    }

    constructor(props) {
        super(props);
        this.state = initialState;
    }

    componentDidMount() {

        setTimeout(() => {
            this.hasCookie();
        }, 1000);

    }

    hasCookie = () => {

        let googleConsent = false;

        try {
            googleConsent = window.BorlabsCookie.getCookie().consents['external-media'].includes('googlemaps')
        } catch (error) {

        }

        try {
            if (googleConsent === false) {
                window.BorlabsCookie.showCookieBox();
            } else {
                this.setState({
                    cookieIsApproved: true
                })
                return true;
            }

        } catch (error) {

        }

        return false;

    };

    handleAcceptCookie = () => {
        if(typeof window.BorlabsCookie === "object") {
            window.BorlabsCookie.unblockContentId("googlemaps");
            this.setState({
                cookieIsApproved: true
            });
        }
    }

    render() {

        const {
            categories,
            members,
            mapProps,
            filter
        } = this.props;

        return (
            <Fragment>


            {
                (this.state.cookieIsApproved) ?
                <Fragment>
                    <GoogleMap
                        mapContainerStyle={{
                            width: '100%',
                            height: this.props.mapProps.height
                        }}
                        center={mapProps.center}
                        zoom={mapProps.zoom}
                        onLoad={(map) => {
                            this.setState({
                                map
                            })
                        }}
                        options={{
                            // these following 7 options turn certain controls off see link below
                            streetViewControl: false,
                            scaleControl: false,
                            mapTypeControl: false,
                            panControl: false,
                            zoomControl: true,
                            rotateControl: false,
                            fullscreenControl: false
                        }}
                    >
                        {
                            members.map((member, index) => {

                                let icon = null;
                                let zIndex = 1;
                                let cat = null;

                                if (filter.categories.length === 1) {
                                    cat = categories.find((gCategory, index) => {
                                        return (
                                            parseInt(gCategory.category_id) === parseInt(filter.categories[0])
                                        )
                                    });
                                } else {
                                    cat = categories.find((gCategory, index) => {
                                        return (
                                            parseInt(gCategory.category_id) === parseInt(member.member_primary_category_id)
                                        )
                                    });
                                }

                                if (cat !== null) {
                                    icon = getMapIcon(cat.category_slug);
                                    zIndex = cat.category_zindex;
                                } else {
                                }

                                return (
                                    <Marker
                                        key={'marker_' + member.member_id}
                                        position={{
                                            lat: parseFloat(member.member_latitude),
                                            lng: parseFloat(member.member_longitude)
                                        }}
                                        onClick={(event) => this.props.onMarkerClick(event, member, index)}
                                        icon={icon}
                                        zIndex={parseInt(zIndex)}
                                    />
                                )
                            })
                        }

                    </GoogleMap>
                </Fragment>
                :
                    <div className="cookie-consent-layer">
                        <br /> <br />
                        <center>Sie müssen unseren Cookies für GoogleMaps akzeptieren.</center>
                        <br />
                        <hr />
                        <br />
                        <center><button onClick={this.handleAcceptCookie}>GoogleMaps Cookie zulassen</button></center>
                    </div>
            }

            </Fragment>

        )
    }

}

export default MapView;
